import React, { ChangeEvent, FC, useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../Components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../Components/ui/select";
import { Input } from "../../Components/ui/input";
import { Label } from "../../Components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../Components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../Components/ui/dropdown-menu";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../Components/ui/table";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../Components/ui/tabs";
import { useToast } from "../../Components/ui/use-toast";
import { RadioGroup, RadioGroupItem } from "../../Components/ui/radio-group";
import { Toaster } from "../../Components/ui/toaster";
import { Button } from "../../Components/ui/button";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../State/store";
import { Switch } from "../../Components/ui/switch";
import { CaretSortIcon, DotsHorizontalIcon } from "@radix-ui/react-icons";
import { CircularProgress } from "@mui/material";
import { HandPlatter } from "lucide-react";
import { toast } from "react-toastify";
import { title } from "process";
import { useLocation, useNavigate } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import {
  CheckCircle,
  Clock,
  FileIcon,
  HelpCircle,
  Loader2,
  XCircle,
} from "lucide-react";
import { Badge } from "../../Components/ui/badge";
import { Info } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../Components/ui/popover";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../Components/ui/tooltip";

interface ShortCodeList {
  campaign_id: number;
  campaign_name: string;
  sms_number: string;
}

interface AvailableShortCodeList {
  shortCode: number;
}

export interface ChannelConfig {
  channel_config_id: number;
  channel_id: number;
  channel_config_name: string;
  channel_status: string;
  partner_type: string;
  partner_id: number;
  wm_template_id?: number | null; // ✅ ADD THIS
  wm_template_name?: string | null;
  channelserver_url: string;
  channelserver_app_status: string;
  channelserver_app_remarks: string;
  created_time: string;
  last_updated_time: string;
  channel_config: string;
  api_type: string;
}

interface ShortCodes {
  code: string;
}

type ChannelUrlItem = {
  url: string;
  channelserver_id: number;
  channelserver_app_id: number;
  channelserver_name: string;
};

const SMS: FC = () => {
  const [phoneNumberList, setPhoneNumberList] = useState<ShortCodeList[]>();
  const [availableShortCodeList, setAvailableShortCodeList] =
    useState<AvailableShortCodeList[]>();
  const [numberList, setNumberList] = useState<string[]>([]);
  const [open, setOpen] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [tableData, setTableData] = useState<ChannelConfig[]>([]);
  const [selectedUrl, setSelectedUrl] = useState<string>("");
  const [selectedChannelServerId, setSelectedChannelServerId] =
    useState<number>(0);
  const [selectedChannelServerAppId, setSelectedChannelServerAppId] =
    useState<number>(0);
  const [channelUrls, setChannelUrls] = useState<ChannelUrlItem[]>([]);
  const [currentChannelId, setCurrentChannelId] = useState<number | null>(null);
  const [isConnectDialogOpen, setIsConnectDialogOpen] = useState(false);
  const [isConnectOpen, setIsConnectOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("smpp");
  const [isCustomDialogOpen, setIsCustomDialogOpen] = useState(false);
  const [isApiExecuting, setIsApiExecuting] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isWelcomeTemplateDialogOpen, setIsWelcomeTemplateDialogOpen] =
    useState(false);

  const [connectionName, setConnectionName] = useState("");
  const [serverType, setServerType] = useState("SMPP");
  const [host, setHost] = useState("");
  const [port, setPort] = useState("");
  const [username, setUsername] = useState("");
  // const [serverType, setServerType] = useState("SMPP");
  const [password, setPassword] = useState("");
  const [activeTab, setActiveTab] = useState("basic");
  const location = useLocation();
  const serverId = location.state?.serverId || " ";
  const role_id = useSelector(
    (state: RootState) => state.authentication.role_id,
  );
  // New State Variables for TON & NPI
  const [bindingTON, setBindingTON] = useState(0);
  const [bindingNPI, setBindingNPI] = useState(0);
  const [senderTON, setSenderTON] = useState(5);
  const [senderNPI, setSenderNPI] = useState(0);
  const [destinationTON, setDestinationTON] = useState(1);
  const [destinationNPI, setDestinationNPI] = useState(1);
  const [shortCode, setShortCode] = useState([
    {
      code: "000",
    },
  ]);

  const [transportProtocol, setTransportProtocol] = useState("TCP");
  const [bindMode, setBindMode] = useState("Transceiver");
  const [addressRange, setAddressRange] = useState("");
  const [systemType, setSystemType] = useState("");
  const [dataCodingScheme, setDataCodingScheme] = useState("8");
  const [characterEncoding, setCharacterEncoding] = useState("UTF-8");
  const [serviceType, setServiceType] = useState("CMT");
  const [maxValidityHours, setMaxValidityHours] = useState(24);
  const [validityType, setValidityType] = useState("Relative");
  const [supportsRelativeValidity, setSupportsRelativeValidity] =
    useState(false);

  const [connectionId, setConnectionId] = useState(0);
  const [channelConfigName, setChannelConfigName] = useState<string>("");
  const [channelConfigId, setChannelConfigId] = useState<number>(0);
  const [channelConfigStatus, setChannelConfigStatus] = useState<string>("");

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [templateSearchQuery, setTemplateSearchQuery] = useState("");

  const [isDeliveryWindowDialogOpen, setIsDeliveryWindowDialogOpen] =
    useState(false);
  const [ttlValue, setTtlValue] = useState<string>("");
  const [unit, setUnit] = useState<"hours" | "days">("hours");

  const workspace = useSelector(
    (state: RootState) => state.authentication.workspaceName,
  );

  const adminurl = useSelector(
    (state: RootState) => state.authentication.adminUrl,
  );
  const workspaceId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );
  const OperatorUrl = useSelector(
    (state: RootState) => state.authentication.operatorUrl,
  );
  const partnerId = useSelector(
    (state: RootState) => state.authentication.workspace_id,
  );
  const isAdmin = useSelector(
    (state: RootState) => state.authentication.isAdmin,
  );
  const impersonatorAID = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonatorAID,
  );

  const isImpersonated = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonationState,
  );

  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id,
  );

  // Calculate pagination values
  // const totalCount = tableData.length;
  // const totalPages = Math.ceil(totalCount / rowsPerPage);
  // const paginatedData = tableData.slice(
  //   (currentPage - 1) * rowsPerPage,
  //   currentPage * rowsPerPage,
  // );

    const [totalCount, setTotalCount] = useState(0);
  
    // Calculate pagination values
    //const totalCount = tableData.length;
    const totalPages = Math.ceil(totalCount / rowsPerPage);
    // const paginatedData = tableData.slice(
    //   (currentPage - 1) * rowsPerPage,
    //   currentPage * rowsPerPage,
    // );
    console.log("tableData:", tableData);
    console.log("tableData length:", tableData.length);

  console.log("isAdmin :-------------" + isAdmin);
  // const partnerId =1701;
  const channelId = location.state.channelId;
  const channelName = location.state.channelName;
  const [openMenuId, setOpenMenuId] = useState<number | null>(null);
  const toast = useToast();
  const navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = useState(false);
  // Add this state at the top with your other states
  const [welcomeTemplateList, setWelcomeTemplateList] = useState<any[]>([]);
  const [selectedWelcomeTemplateId, setSelectedWelcomeTemplateId] =
    useState<string>("");
  const [selectedChannelConfigId, setSelectedChannelConfigId] =
    useState<number>(0);

  const [openRow, setOpenRow] = useState<number | null>(null);

  // Add this function to fetch templates
  const fetchWelcomeTemplates = async (
    channelConfigId: number,
    channelId: number, // 👈 this is channelType logically
  ) => {
    debugger;
    try {
      const response = await axios.get(
        `${OperatorUrl}/GetTemplatesByPartnerAndChannel`,
        {
          params: {
            channelConfigId,
            channelType: channelId, // 👈 explicit mapping
          },
        },
      );
      debugger;
      if (response.data.status === "Success") {
        setWelcomeTemplateList(response.data.data || []);
        debugger;
        setSelectedChannelConfigId(channelConfigId);
        console.log("welcometemplatelist", welcomeTemplateList);
      }
    } catch (error) {
      console.error("Error fetching welcome templates:", error);
    }
  };

useEffect(() => {
  fetchChannelConfigs(partnerId); // 👈 pass explicitly
  // eslint-disable-next-line
}, [partnerId, currentPage, rowsPerPage]);


  const handleInputChange = (name: string, value: string | number) => {
    switch (name) {
      case "connectionName":
        setConnectionName(value as string);
        break;
      case "host":
        setHost(value as string);
        break;
      case "port":
        setPort(value as string);
        break;
      case "username":
        setUsername(value as string);
        break;
      case "password":
        setPassword(value as string);
        break;
      case "bindingTON":
        setBindingTON(Number(value));
        break;
      case "bindingNPI":
        setBindingNPI(Number(value));
        break;
      case "senderTON":
        setSenderTON(Number(value));
        break;
      case "senderNPI":
        setSenderNPI(Number(value));
        break;
      case "destinationTON":
        setDestinationTON(Number(value));
        break;
      case "destinationNPI":
        setDestinationNPI(Number(value));
        break;
    }
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const addShortCode = () => {
    setShortCode([
      ...shortCode,
      {
        code: "000",
      },
    ]);
  };

  const removeShortCode = (index: number) => {
    const updatedShortCodes = shortCode.filter((_, i) => i !== index);
    setShortCode(updatedShortCodes);
  };

  const shortCodeChange = (
    index: number,
    field: keyof ShortCodes,
    value: string,
  ) => {
    const updatedShortCode = [...shortCode];
    updatedShortCode[index] = {
      ...updatedShortCode[index],
      [field]: value,
    } as unknown as ShortCodes;
    setShortCode(updatedShortCode);
  };

  const handleToggle = (itemId: number) => {
    setOpenMenuId((prev) => (prev === itemId ? null : itemId));
  };

  // const handleTTLChange = (value: string) => {
  //   const num = Number(value);
  //   if (num < 2 || num > 72) return;
  //   setTtlValue(value);
  // };

  // Change handler — no validation, just set the value
  const handleTTLChange = (value: string) => {
    setTtlValue(value);
  };

  // Blur handler — validate when user leaves the field
  const handleTTLBlur = () => {
    const num = Number(ttlValue);
    if (!ttlValue || num < 2) setTtlValue("2");
    if (num > 72) setTtlValue("72");
  };

  const getTTLHours = async (channelConfigId: number) => {
    try {
      const response = await axios.get(`${OperatorUrl}/GetTTLHours`, {
        params: { ChannelConfigId: channelConfigId, ChannelId: channelId },
      });

      debugger;
      if (response.data?.status === "Success") {
        const ttlHours = response.data.msg_validity_hours;

        // if (ttlHours > 24 && ttlHours % 24 === 0) {
        //   setUnit("days");
        //   setTtlValue(String(ttlHours / 24));
        // } else {
        //   setUnit("hours");
        //   setTtlValue(String(ttlHours));
        // }

        setUnit("hours");
        setTtlValue(String(ttlHours));
      }
    } catch (error) {
      console.error("Failed to fetch TTL:", error);
    }
  };

  const updateDeliveryWindow = async (
    value: number,
    unit: string,
    channelConfigId: number,
  ) => {
    try {
      setIsUpdating(true);

      // Convert to hours for backend
      let MessageValidityHours = value;
      //if (unit === "days") MessageValidityHours = value * 24;
      // if (unit === "weeks") ttlInHours = value * 24 * 7;

      if (MessageValidityHours < 2 || MessageValidityHours > 72) {
        toast.toast({
          title: "Invalid Input",
          description: "SMS validity must be between 2 and 72 hours",
          variant: "destructive",
        });
        return;
      }

      const payload = {
        ChannelConfigId: channelConfigId,
        ChannelId: channelId,
        MessageValidityHours: MessageValidityHours,
        ChannelType: channelName,
        partnerId: partnerId,
        accountId: accountId,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      const response = await axios.put(
        `${OperatorUrl}/UpdateTTLHours`,
        payload,
      );

      if (response.data) {
        toast.toast({
          title: "Success",
          description: "Message validity period updated successfully",
        });
        fetchChannelConfigs(partnerId);
      }
    } catch (error: any) {
      toast.toast({
        title: "Error",
        description:
          error.response?.data?.message ||
          "Failed to update Message validity period",
        variant: "destructive",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  const getChannelConfigById = async (configId: number) => {
    setIsUpdate(true);
    try {
      setLoading(true);

      const response = await axios.get(
        `${OperatorUrl}/GetChannelConfigByConfigId`,
        {
          params: { configId },
        },
      );

      debugger;
      const details = response.data.channelConfigDetails;

      // ✅ Handle both string and object
      const parsed = JSON.parse(details.channel_config);
      const config = parsed.config;

      setChannelConfigId(details.channel_config_id);
      setChannelConfigName(details.channel_config_name);
      setChannelConfigStatus(details.channel_status);
      let config2 = JSON.parse(details.channel_config);
      setSelectedOption(config2.api_type);
      setSelectedUrl(details.channelserver_url);

      setHost(config.host || "");
      setPort(config.port || "");
      setUsername(config.system_id || "");
      setPassword(config.password || "");
      setBindMode(
        config.bind_mode === 1
          ? "Transmitter"
          : config.bind_mode === 2
            ? "Receiver"
            : "Transceiver",
      );
      setBindingTON(config.binding_ton ?? 0);
      setBindingNPI(config.binding_npi ?? 0);
      setSenderTON(config.sender_ton ?? 0);
      setSenderNPI(config.sender_npi ?? 0);
      setDestinationTON(config.destination_ton ?? 0);
      setDestinationNPI(config.destination_npi ?? 0);
      setSystemType(config.system_type || "");
      setServiceType(config.service_type || "");
      setAddressRange(config.address_range || "");
      setDataCodingScheme(config.data_coding || "8");
      setCharacterEncoding(config.character_encoding || "UTF-8");
      setTransportProtocol(config.transport_protocol || "TCP");
      setMaxValidityHours(config.max_validity_hours ?? 24);
      setValidityType(config.validity_type || "Relative");
      setSupportsRelativeValidity(config.supports_relative_validity ?? false);

      // ✅ Only parse `channel_config` string if it exists
      if (config.sms_short_codes) {
        try {
          const shortCodes =
            typeof config.sms_short_codes === "string"
              ? JSON.parse(config.sms_short_codes)
              : config.sms_short_codes;

          setShortCode(shortCodes.map((code: any) => ({ code }))); // <- assumes setShortCodes exists
        } catch (e) {
          console.warn("Failed to parse ShortCodes:", e);
          setShortCode([]); // fallback
        }
      }

      if (parsed.api_type === "smpp" && !isDeleteDialogOpen) {
        setIsCustomDialogOpen(true);
      }
    } catch (err: any) {
      console.error("Failed to fetch config:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    debugger;
    await getChannelConfigById(channelConfigId);

    const configPayload = {
      config: {
        host: host,
        port: port,
        type: "",
        use_ssl: transportProtocol == "TCP" ? false : true,
        system_id: username,
        password: password,
        server_id: serverId,
        binding_ton: bindingTON,
        binding_npi: bindingNPI,
        sender_ton: senderTON,
        sender_npi: senderNPI,
        destination_ton: destinationTON,
        destination_npi: destinationNPI,

        // ✅ ADD THESE
        max_validity_hours: maxValidityHours,
        validity_type: validityType,

        sms_short_codes:
          shortCode.length > 0
            ? JSON.stringify(shortCode.map((sc) => sc.code))
            : "[]",

        transport_protocol: transportProtocol,
        bind_mode: Number(connectionResolver("bindMode", bindMode)),
        address_range: addressRange,
        system_type: systemType,
        data_coding: dataCodingScheme,
        character_encoding: characterEncoding,
        service_type: serviceType,
      },
      api_type: selectedOption,
      api_vendor: workspace,
      channel_id: channelId,
      channel_type: channelName,
    };

    const payload = {
      channel_config_id: channelConfigId,
      channelConfigName: channelConfigName,
      channelStatus: channelConfigStatus,
      channelConfig: JSON.stringify(configPayload),
      channelserver_url: selectedUrl,
      channelserver_Id: selectedChannelServerId,
      channelserver_app_Id: selectedChannelServerAppId,
      channel_Id: channelId,
      channelserver_app_Status: "inactive",
      accountId: accountId,
      partnerId: partnerId,
      ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
    };

    setIsApiExecuting(true);

    try {
      const response = await axios.delete(
        `${OperatorUrl}/DeleteChannelConfig`,
        {
          data: payload, // send as request body
        },
      );

      const data = response.data; // parsed JSON

      if (data.status === "Failure" || data.status === "Warning") {
        setIsDeleteDialogOpen(false);
        setIsUpdate(false);
        setConnectionName("");
        setHost("");
        setPort("");
        setUsername("");
        setPassword("");
        setAddressRange("");
        setSystemType("");
        setServiceType("CMT");
        setDataCodingScheme("8");
        setCharacterEncoding("UTF-8");
        setShortCode([{ code: "000" }]);

        toast.toast({
          title: "Warning",
          description: data.status_Description || "Failed to delete",
        });
      } else {
        setIsDeleteDialogOpen(false);
        setIsUpdate(false);
        setConnectionName("");
        setHost("");
        setPort("");
        setUsername("");
        setPassword("");
        setAddressRange("");
        setSystemType("");
        setServiceType("CMT");
        setDataCodingScheme("8");
        setCharacterEncoding("UTF-8");
        setShortCode([{ code: "000" }]);

        toast.toast({
          title: "Success",
          description: data.status_Description || "Deleted successfully",
          variant: "default",
        });

        setIsDeleteDialogOpen(false);
        fetchChannelConfigs(partnerId); // refresh the list
      }
    } finally {
      setIsApiExecuting(false);
      setIsUpdate(false);
      setConnectionName("");
      setHost("");
      setPort("");
      setUsername("");
      setPassword("");
      setAddressRange("");
      setSystemType("");
      setServiceType("CMT");
      setDataCodingScheme("8");
      setCharacterEncoding("UTF-8");
      setShortCode([{ code: "000" }]);
    }
  };

  const handleStatusToggle = async (
    configId: number,
    currentStatus: string,
  ) => {
    if (!configId || !currentStatus) {
      toast.toast({
        title: "Validation Error",
        description: "Invalid configuration ID or status.",
      });
      return;
    }

    const newStatus =
      currentStatus.toLowerCase() === "active" ? "inactive" : "active";

    try {
      const response = await axios.put(
        `${OperatorUrl}/UpdateChannelStatus`,
        null,
        {
          params: {
            configId,
            newStatus,
            accountId: accountId,
            partnerId: partnerId,
            channelType: channelName,
            ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
          },
        },
      );

      if (response.status === 200 && response.data) {
        toast.toast({
          title: "Status Updated",
          description: `Configuration status changed to ${newStatus}`,
        });

        fetchChannelConfigs(partnerId);
      } else {
        toast.toast({
          title: "Update Failed",
          description: "Unexpected response from the server.",
        });
      }
    } catch (error: any) {
      console.error("Error updating channel status:", error);

      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update channel status.";

      toast.toast({
        title: "Error",
        description: errorMessage,
      });
    } finally {
      setOpenMenuId(null);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      document.body.style.pointerEvents = "";
    }, 500);
    setActiveTab("basic");
  }, [
    isConnectDialogOpen,
    isDeleteDialogOpen,
    isCustomDialogOpen,
    isWelcomeTemplateDialogOpen,
  ]);

 const fetchChannelConfigs = async (partnerId: number) => {
  try {
    setIsRefreshing(true);
    const response = await axios.get(
      `${OperatorUrl}/GetChannelConfigsByPartnerId`,
        {
          params: {
            partnerId,
            channelId,
            page: currentPage,
            pageSize: rowsPerPage,
          },
        },
    );
    if (response.data.channelConfigs?.length > 0) {
      setTableData(response.data.channelConfigs);
      setTotalCount(response.data.total);
    } else {
      setTableData([]);
      setTotalCount(0);
    }
  } catch (err: any) {
    console.error("Error fetching configs:", err);
    setTableData([]);
    setTotalCount(0);
  } finally {
    setLoading(false);
    setIsRefreshing(false);
    setTimeout(() => {
      document.body.style.pointerEvents = "";
    }, 500);
  }
};

  const connectionResolver = (item: string, value: string) => {
    if (item === "bindMode") {
      if (value === "Transceiver") {
        return 3;
      } else if (value === "Receiver") {
        return 2;
      } else if (value === "Transmitter") {
        return 1;
      }
    }
  };

  const fetchChannelServerUrls = async () => {
    try {
      const response = await axios.get(
        `${OperatorUrl}/GetChannelServerDetailsByChannelId?channelId=${channelId}`,
      );

      const serverList = response.data.channelServerDetails;

      if (serverList && serverList.length > 0) {
        const urls = serverList.map((item: any) => ({
          url: `${item.channelserver_ip}:${item.channelserver_app_port}`,
          channelserver_id: item.channelserver_id,
          channelserver_app_id: item.channelserver_app_id,
          channelserver_name: item.channelserver_name,
        }));

        setChannelUrls(urls);
      } else {
        setChannelUrls([]); // No data found
      }
    } catch (err: any) {
      console.error("Error fetching configs:", err);
      // setError("Failed to fetch channel configs.");
    } finally {
      setLoading(false);
    }
  };

  //   const handleRefresh = async () => {
  //   try {
  //     const response = await axios.get("http://your-api-url.com/refresh"); // Replace with actual API
  //     console.log("Refreshed data:", response.data);
  //     // Optionally show success toast
  //   } catch (error) {
  //     console.error("Failed to refresh:", error);
  //   }
  // };

  const openDeleteDialog = (id: number, name: string) => {
    setChannelConfigId(id);
    setChannelConfigName(name);
    setIsDeleteDialogOpen(true);
  };

  const handleUpdateChannelServerUrl = async () => {
    if (!selectedUrl || currentChannelId === null) {
      toast.toast({
        title: "Missing Selection",
        description: "Please select a valid URL and configuration.",
      });
      return;
    }

    try {
      setIsUpdating(true);

      const response = await axios.post(
        `${OperatorUrl}/UpdateChannelServerUrl`,
        {
          channel_config_id: currentChannelId,
          channelserver_url: selectedUrl,
          channelserver_Id: selectedChannelServerId,
          channelserver_app_Id: selectedChannelServerAppId,
          channel_Id: channelId,
          channelserver_app_Status: "inactive",
          accountId: accountId,
          partnerId: partnerId,
          channelType: channelName,
          ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
        },
      );

      const data = response.data;

      if (data.success === false) {
        toast.toast({
          title: "Update Failed",
          description:
            data.message ||
            "Something went wrong while updating the channel server.",
        });
      } else if (data.channelMaintenanceStatus === "offline") {
        toast.toast({
          title: "Success",
          description: data.message, // If using shadcn or want to style it differently
        });
      } else if (data.channelMaintenanceStatus === "exception") {
        toast.toast({
          title: "Success",
          description: data.message, // If using shadcn or want to style it differently
        });
        setIsConnectDialogOpen(false);
        fetchChannelConfigs(partnerId);
      } else {
        toast.toast({
          title: "Success",
          description:
            data.message || "Channel server URL updated successfully.",
        });
        setIsConnectDialogOpen(false);
        fetchChannelConfigs(partnerId);
      }
    } catch (err: any) {
      console.error("Update failed", err);
      toast.toast({
        title: "Error",
        description:
          err?.response?.data?.message ||
          "Failed to update channel server URL.",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  const handleSubmit = async () => {
    debugger;
    if (!host || !port || !username || !password) {
      toast.toast({
        title: "Missing Required Fields",
        description: "Please fill in all required fields before submitting.",
      });
      return;
    }

    try {
      const configPayload = {
        config: {
          host: host,
          port: port,
          type: "",
          use_ssl: transportProtocol == "TCP" ? false : true,
          system_id: username,
          password: password,
          server_id: serverId,
          binding_ton: bindingTON,
          binding_npi: bindingNPI,
          sender_ton: senderTON,
          sender_npi: senderNPI,
          destination_ton: destinationTON,
          destination_npi: destinationNPI,
          sms_short_codes:
            shortCode.length > 0
              ? JSON.stringify(shortCode.map((sc) => sc.code))
              : "[]",
          transport_protocol: transportProtocol,
          bind_mode: Number(connectionResolver("bindMode", bindMode)),
          address_range: addressRange,
          system_type: systemType,
          data_coding: dataCodingScheme,
          character_encoding: characterEncoding,
          service_type: serviceType,
          max_validity_hours: maxValidityHours,
          validity_type: validityType,
          supports_relative_validity: supportsRelativeValidity,
        },
        api_type: selectedOption,
        api_vendor: workspace,
        channel_id: channelId,
        channel_type: channelName,
      };

      const nameResponse = await axios.get(
        `${OperatorUrl}/GenerateChannelConfigName`,
        {
          params: {
            workspace: workspace,
            configType: selectedOption,
          },
        },
      );

      if (!nameResponse.data?.channelConfigName) {
        toast.toast({
          title: "Error",
          description: "Failed to generate configuration name.",
        });
        return;
      }

      const channelConfigName = nameResponse.data.channelConfigName;

      const payload = {
        ChannelId: Number(channelId),
        ChannelConfigName: channelConfigName,
        ChannelConfig: JSON.stringify(configPayload),
        ChannelStatus: "active",
        PartnerId: workspaceId,
        accountId: accountId,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      const insertResponse = await axios.post(
        `${OperatorUrl}/InsertChannelConfig`,
        payload,
      );

      if (insertResponse.status === 200) {
        toast.toast({
          title: "Success",
          description: "Channel config inserted successfully.",
        });
        setIsCustomDialogOpen(false);

        // Reset form states to initial or default values
        setConnectionName("");
        setHost("");
        setPort("");
        setUsername("");
        setPassword("");
        setAddressRange("");
        setSystemType("");
        setServiceType("CMT");
        setDataCodingScheme("8");
        setCharacterEncoding("UTF-8");
        setShortCode([{ code: "000" }]);

        fetchChannelConfigs(partnerId);
      } else {
        toast.toast({
          title: "Insert Failed",
          description: "Unexpected response from server.",
        });
      }
    } catch (error: any) {
      console.error("❌ Submission error:", error);
      toast.toast({
        title: "Error",
        description:
          error?.response?.data?.error ||
          "Failed to submit configuration. Please check and try again.",
      });
    }
  };

  const updateTemplateMapping = async (
    channelConfigId: number,
    templateId: number,
  ) => {
    try {
      const response = await axios.put(
        `${OperatorUrl}/UpdateTemplateId`, // ✅ Replace with your actual controller name
        {
          ChannelConfigId: channelConfigId,
          TemplateId: templateId,
        },
      );

      if (response.status === 200) {
        toast.toast({
          title: "Success",
          description: "Template Linked successfully",
        });
        setIsWelcomeTemplateDialogOpen(false);
        fetchChannelConfigs(partnerId); // Refresh the table
      }
    } catch (error: any) {
      toast.toast({
        title: "Error",
        description:
          error.response?.data?.message || "Failed to update template mapping",
      });
    }
  };

  const handleUpdate = async () => {
    debugger;
    if (!host || !port || !username || !password) {
      toast.toast({
        title: "Missing Required Fields",
        description: "Please fill in all required fields before submitting.",
      });
      return;
    }

    try {
      const configPayload = {
        config: {
          host: host,
          port: port,
          type: "",
          use_ssl: transportProtocol == "TCP" ? false : true,
          system_id: username,
          password: password,
          server_id: serverId,
          binding_ton: bindingTON,
          binding_npi: bindingNPI,
          sender_ton: senderTON,
          sender_npi: senderNPI,
          destination_ton: destinationTON,
          destination_npi: destinationNPI,
          sms_short_codes:
            shortCode.length > 0
              ? JSON.stringify(shortCode.map((sc) => sc.code))
              : "[]",
          transport_protocol: transportProtocol,
          bind_mode: Number(connectionResolver("bindMode", bindMode)),
          address_range: addressRange,
          system_type: systemType,
          data_coding: dataCodingScheme,
          character_encoding: characterEncoding,
          service_type: serviceType,
          max_validity_hours: maxValidityHours,
          validity_type: validityType,
          supports_relative_validity: supportsRelativeValidity,
        },
        api_type: selectedOption,
        api_vendor: workspace,
        channel_id: channelId,
        channel_type: channelName,
      };

      const payload = {
        channel_config_id: channelConfigId,
        channelConfigName: channelConfigName,
        channelStatus: channelConfigStatus,
        channelConfig: JSON.stringify(configPayload),
        channelserver_url: selectedUrl,
        channelserver_Id: selectedChannelServerId,
        channelserver_app_Id: selectedChannelServerAppId,
        channel_Id: channelId,
        channelserver_app_Status: "inactive",
        accountId: accountId,
        partnerId: partnerId,
        ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null,
      };

      const updateResponse = await axios.put(
        `${OperatorUrl}/UpdateChannelConfig`,
        payload,
      );

      const { status, status_Description } = updateResponse.data;

      if (
        status === "Failure" ||
        (status === "Warning" &&
          status_Description?.includes("is already in use"))
      ) {
        setIsCustomDialogOpen(false);
        setIsUpdate(false);
        setConnectionName("");
        setHost("");
        setPort("");
        setUsername("");
        setPassword("");
        setAddressRange("");
        setSystemType("");
        setServiceType("CMT");
        setDataCodingScheme("8");
        setCharacterEncoding("UTF-8");
        setShortCode([{ code: "000" }]);
        toast.toast({
          title: "Warning",
          description:
            updateResponse.data.status_Description || "Failed to update",
        });
      } else {
        setIsCustomDialogOpen(false);
        setIsUpdate(false);
        setConnectionName("");
        setHost("");
        setPort("");
        setUsername("");
        setPassword("");
        setAddressRange("");
        setSystemType("");
        setServiceType("CMT");
        setDataCodingScheme("8");
        setCharacterEncoding("UTF-8");
        setShortCode([{ code: "000" }]);

        toast.toast({
          title: "Success",
          description:
            updateResponse.data.status_Description || "Updated successfully",
          variant: "default",
        });
        setIsCustomDialogOpen(false);

        fetchChannelConfigs(partnerId);
      }
    } catch (error: any) {
      setIsUpdate(false);
      setConnectionName("");
      setHost("");
      setPort("");
      setUsername("");
      setPassword("");
      setAddressRange("");
      setSystemType("");
      setServiceType("CMT");
      setDataCodingScheme("8");
      setCharacterEncoding("UTF-8");
      setShortCode([{ code: "000" }]);
      console.error("❌ Submission error:", error);
      toast.toast({
        title: "Error",
        description:
          error?.response?.data?.error ||
          "Failed to submit configuration. Please check and try again.",
      });
    }
  };
  return (
    <>
      <>
        <Dialog open={isCustomDialogOpen} onOpenChange={setIsCustomDialogOpen}>
          <Toaster />
          <DialogContent className="overflow-y-auto max-h-[90%] p-8 mt-2 mb-6">
            <Tabs
              value={activeTab}
              onValueChange={setActiveTab}
              className="w-full h-full"
            >
              <TabsList className="grid w-full grid-cols-2">
                <TabsTrigger value="basic">Basic</TabsTrigger>
                <TabsTrigger value="advanced">Advanced</TabsTrigger>
              </TabsList>

              {/* Basic Configuration */}
              <TabsContent value="basic">
                <Card>
                  <CardContent className="space-y-2 p-6 pt-8 flex flex-col gap-2">
                    {serverType === "SMPP" && (
                      <>
                        <div className="flex gap-2">
                          <div className="w-[50%]">
                            <Label className="mb-2 text-[#020617] text-14px font-medium">
                              Host
                            </Label>
                            <Input
                              value={host}
                              className="mt-2"
                              onChange={(e) =>
                                handleInputChange("host", e.target.value)
                              }
                            />
                          </div>

                          <div className="w-[50%]">
                            {" "}
                            <Label className="mb-2 text-[#020617] text-14px font-medium">
                              Port
                            </Label>
                            <Input
                              value={port}
                              className="mt-2"
                              onChange={(e) =>
                                handleInputChange("port", e.target.value)
                              }
                            />
                          </div>
                        </div>

                        <div>
                          <Label className="mb-2 text-[#020617] text-14px font-medium">
                            Username
                          </Label>
                          <Input
                            value={username}
                            className="mt-2"
                            onChange={(e) =>
                              handleInputChange("username", e.target.value)
                            }
                          />
                        </div>

                        <div>
                          <Label className="mb-1 text-[#020617] text-14px font-medium">
                            Password
                          </Label>
                          <Input
                            type="password"
                            className="mt-2"
                            value={password}
                            onChange={(e) =>
                              handleInputChange("password", e.target.value)
                            }
                          />
                        </div>

                        <div className="flex flex-col">
                          <Label className="mb-2 text-[#020617] text-14px font-medium">
                            Short Codes
                          </Label>

                          {shortCode.map((code, index) => (
                            <div
                              key={index}
                              className="flex items-center gap-2 mb-1"
                            >
                              <Input
                                autoFocus
                                value={code.code}
                                onChange={(e) =>
                                  shortCodeChange(index, "code", e.target.value)
                                }
                                className="w-full"
                              />

                              {shortCode.length > 1 && (
                                <span>
                                  <button
                                    onClick={() => removeShortCode(index)}
                                  >
                                    ✕
                                  </button>
                                </span>
                              )}
                            </div>
                          ))}

                          <div className="flex justify-end">
                            <Button
                              className="w-[30%] mt-0"
                              variant="link"
                              onClick={() => {
                                addShortCode();
                              }}
                            >
                              + Add
                            </Button>
                          </div>
                        </div>
                      </>
                    )}
                  </CardContent>
                  <CardFooter>
                    <Button
                      className="w-full"
                      onClick={() => setActiveTab("advanced")}
                    >
                      Next
                    </Button>
                  </CardFooter>
                </Card>
              </TabsContent>

              <TabsContent value="advanced">
                <Card>
                  <CardContent className="space-y-2 p-6 pt-8 flex flex-col gap-4">
                    {serverType === "SMPP" && (
                      <>
                        <div className="flex flex-col gap-2">
                          <Label
                            htmlFor="binding-address"
                            className="text-14px font-medium text-[#020617]"
                          >
                            Binding Address
                          </Label>

                          <div
                            className="flex w-full items-center gap-2"
                            id="binding-address"
                          >
                            <Label
                              htmlFor="binding-address"
                              className="text-14px font-medium text-[#020617]"
                            >
                              TON
                            </Label>
                            <Input
                              id="binding-address"
                              type="number"
                              value={bindingTON}
                              onChange={(e) =>
                                handleInputChange("bindingTON", e.target.value)
                              }
                              className="text-[14px] font-normal placeholder:text-[#64748B] w-[47%]"
                            />

                            <Label
                              htmlFor="binding-address"
                              className="text-14px font-medium text-[#020617]"
                            >
                              NPI
                            </Label>
                            <Input
                              id="binding-address"
                              type="number"
                              value={bindingNPI}
                              onChange={(e) =>
                                handleInputChange("bindingNPI", e.target.value)
                              }
                              className="text-[14px] font-normal placeholder:text-[#64748B] w-[47%]"
                            />
                          </div>
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label
                            htmlFor="binding-address"
                            className="text-14px font-medium text-[#020617]"
                          >
                            Sender Address
                          </Label>

                          <div
                            className="flex w-full items-center gap-2"
                            id="binding-address"
                          >
                            <Label
                              htmlFor="binding-address"
                              className="text-14px font-medium text-[#020617]"
                            >
                              TON
                            </Label>
                            <Input
                              id="binding-address"
                              type="number"
                              value={senderTON}
                              onChange={(e) =>
                                handleInputChange("senderTON", e.target.value)
                              }
                              className="text-[14px] font-normal placeholder:text-[#64748B]"
                            />

                            <Label
                              htmlFor="binding-address"
                              className="text-14px font-medium text-[#020617]"
                            >
                              NPI
                            </Label>
                            <Input
                              id="binding-address"
                              type="number"
                              value={senderNPI}
                              onChange={(e) =>
                                handleInputChange("senderNPI", e.target.value)
                              }
                              className="text-[14px] font-normal placeholder:text-[#64748B]"
                            />
                          </div>
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label
                            htmlFor="binding-address"
                            className="text-14px font-medium text-[#020617]"
                          >
                            Destination Address
                          </Label>

                          <div
                            className="flex w-full gap-2 items-center"
                            id="binding-address"
                          >
                            <Label
                              htmlFor="binding-address"
                              className="text-14px font-medium text-[#020617]"
                            >
                              TON
                            </Label>
                            <Input
                              id="binding-address"
                              type="number"
                              value={destinationTON}
                              onChange={(e) =>
                                handleInputChange(
                                  "destinationTON",
                                  e.target.value,
                                )
                              }
                              className="text-[14px] font-normal placeholder:text-[#64748B] w-[47%]"
                            />

                            <Label
                              htmlFor="binding-address"
                              className="text-14px font-medium text-[#020617]"
                            >
                              NPI
                            </Label>
                            <Input
                              id="binding-address"
                              type="number"
                              value={destinationNPI}
                              onChange={(e) =>
                                handleInputChange(
                                  "destinationNPI",
                                  e.target.value,
                                )
                              }
                              className="text-[14px] font-normal placeholder:text-[#64748B] w-[47%]"
                            />
                          </div>
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label className="text-14px font-medium text-[#020617]">
                            Transport Protocol
                          </Label>
                          <Select
                            value={transportProtocol}
                            onValueChange={setTransportProtocol}
                          >
                            <SelectTrigger>
                              <SelectValue placeholder="Select Protocol" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="TCP">TCP</SelectItem>
                              <SelectItem value="SSL">SSL</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label className="text-14px font-medium text-[#020617]">
                            Bind Mode
                          </Label>
                          <Select value={bindMode} onValueChange={setBindMode}>
                            <SelectTrigger>
                              <SelectValue placeholder="Select Bind Mode" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="Transceiver">
                                Transceiver
                              </SelectItem>
                              <SelectItem value="Receiver">Receiver</SelectItem>
                              <SelectItem value="Transmitter">
                                Transmitter
                              </SelectItem>
                            </SelectContent>
                          </Select>
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label className="text-14px font-medium text-[#020617]">
                            Address Range
                          </Label>
                          <Input
                            type="text"
                            value={addressRange}
                            onChange={(e) => setAddressRange(e.target.value)}
                            className="text-[14px] font-normal placeholder:text-[#64748B]"
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label className="text-14px font-medium text-[#020617]">
                            System Type
                          </Label>
                          <Input
                            type="text"
                            value={systemType}
                            onChange={(e) => setSystemType(e.target.value)}
                            className="text-[14px] font-normal placeholder:text-[#64748B]"
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label className="text-14px font-medium text-[#020617]">
                            Service Type
                          </Label>
                          <Input
                            type="text"
                            value={serviceType}
                            onChange={(e) => setServiceType(e.target.value)}
                            className="text-[14px] font-normal placeholder:text-[#64748B]"
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label className="text-14px font-medium text-[#020617]">
                            Data Coding Scheme
                          </Label>
                          <Input
                            type="text"
                            value={dataCodingScheme}
                            onChange={(e) =>
                              setDataCodingScheme(e.target.value)
                            }
                            className="text-[14px] font-normal placeholder:text-[#64748B]"
                          />
                        </div>

                        <div className="flex flex-col gap-2">
                          <Label className="text-14px font-medium text-[#020617]">
                            Character Encoding
                          </Label>
                          <Select
                            value={characterEncoding}
                            onValueChange={setCharacterEncoding}
                          >
                            <SelectTrigger>
                              <SelectValue placeholder="Select Encoding" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="UTF-8">UTF-8</SelectItem>
                              <SelectItem value="UTF-16">UTF-16</SelectItem>
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="flex flex-col w-full gap-1">
                          <Label
                            htmlFor="max-validity-hours"
                            className="text-[14px] font-medium text-[#020617]"
                          >
                            Message Validity Period
                          </Label>

                          <Input
                            id="max-validity-hours"
                            type="number"
                            value={maxValidityHours}
                            onChange={(e) => {
                              const value = Number(e.target.value);
                              if (value >= 2 && value <= 72) {
                                setMaxValidityHours(value);
                              }
                            }}
                            className="text-[14px]"
                          />
                        </div>

                        <div className="flex w-full gap-4 mt-4">
                          {/* Validity Type */}
                          <div className="flex flex-col w-[50%] gap-1">
                            <Label className="text-[14px] font-medium text-[#020617]">
                              Validity Type
                            </Label>

                            <Select
                              value={validityType}
                              onValueChange={(value) => setValidityType(value)}
                            >
                              <SelectTrigger className="text-[14px] w-[90%]">
                                <SelectValue placeholder="Select validity type" />
                              </SelectTrigger>

                              <SelectContent>
                                <SelectItem value="Relative">
                                  Relative
                                </SelectItem>
                                <SelectItem value="Absolute">
                                  Absolute
                                </SelectItem>
                              </SelectContent>
                            </Select>
                          </div>

                          {/* Supports Relative Validity */}
                          <div className="flex flex-col w-[50%] gap-1">
                            <Label className="text-[14px] font-medium text-[#020617]">
                              Supports Relative Validity
                            </Label>

                            <div className="flex items-center gap-3 h-[40px]">
                              <Switch
                                checked={supportsRelativeValidity}
                                onCheckedChange={(checked) =>
                                  setSupportsRelativeValidity(checked)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </CardContent>
                  <CardFooter className="flex w-full flex-end justify-end">
                    <Button
                      className="w-[30%] "
                      onClick={() => {
                        handleTabChange("basic");
                      }}
                    >
                      Back
                    </Button>

                    <Button
                      className="w-[30%] ml-[40%]"
                      onClick={isUpdate ? handleUpdate : handleSubmit}
                    >
                      {isUpdate ? "Update" : "Submit"}
                    </Button>
                  </CardFooter>
                </Card>
              </TabsContent>
            </Tabs>
          </DialogContent>
        </Dialog>

        <Dialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
          <DialogContent className="w-full max-w-md">
            <DialogHeader>
              <DialogTitle>Confirm Delete</DialogTitle>
            </DialogHeader>

            <div>
              Are you sure you want to delete this channel configuration?
            </div>

            <DialogFooter className="mt-6 flex justify-end space-x-3">
              <Button
                variant="outline"
                className="w-24 hover:bg-red-500 hover:text-white border-red-500 text-red-500"
                onClick={() => setIsDeleteDialogOpen(false)}
                //disabled={isApiExecuting}
              >
                Cancel
              </Button>

              <Button
                className="text-white w-24"
                onClick={handleDelete}
                //disabled={isApiExecuting}
              >
                OK
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <Dialog open={isConnectOpen} onOpenChange={setIsConnectOpen}>
          <DialogContent className="w-full max-w-xl">
            <DialogHeader>
              <DialogTitle>Connect SMS Account</DialogTitle>
              <DialogDescription className="mb-4">
                Please choose how you want to connect your SMS account.
              </DialogDescription>
            </DialogHeader>

            <RadioGroup
              value={selectedOption}
              onValueChange={setSelectedOption}
              className="space-y-3"
            >
              <div className="flex items-center space-x-2 cursor-pointer">
                <RadioGroupItem value="smpp" id="smpp" className="h-4 w-4" />
                <Label htmlFor="smpp" className="cursor-pointer">
                  SMPP
                </Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="rest" id="rest" className="h-4 w-4" />
                <Label htmlFor="rest" className="cursor-pointer">
                  REST
                </Label>
              </div>
            </RadioGroup>

            <DialogFooter className="mt-6">
              <Button
                variant="outline"
                className="w-24 hover:bg-red-500 hover:text-white border-red-500 text-red-500"
                onClick={() => setIsCustomDialogOpen(false)}
                disabled={isApiExecuting}
              >
                Cancel
              </Button>

              <Button
                className="text-white w-24"
                onClick={async () => {
                  if (selectedOption === "standard") {
                    //launchWhatsAppSignup("connect");
                  } else if (selectedOption === "smpp") {
                    setIsConnectOpen(false);
                    setIsCustomDialogOpen(true);
                  }
                }}
                disabled={isApiExecuting}
              >
                {"Next >"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <Dialog
          open={isConnectDialogOpen}
          onOpenChange={setIsConnectDialogOpen}
        >
          <DialogContent className="w-full max-w-xl">
            <DialogHeader>
              <DialogTitle className="text-lg font-semibold text-[#09090B] mb-2">
                Connect to channel server
              </DialogTitle>
            </DialogHeader>

            <div className="w-full max-w-xl">
              <label className="mb-2 block text-sm font-medium">
                Select Server URL
              </label>
              <Select
                value={selectedUrl}
                onValueChange={(value) => {
                  setSelectedUrl(value);
                  const selected = channelUrls.find(
                    (item) => item.url === value,
                  );
                  if (selected) {
                    setSelectedChannelServerId(selected.channelserver_id);
                    setSelectedChannelServerAppId(
                      selected.channelserver_app_id,
                    );
                  }
                }}
              >
                <SelectTrigger className="w-full text-sm border-gray-300 hover:border-gray-400">
                  <SelectValue placeholder="Select URL" />
                </SelectTrigger>
                <SelectContent className="w-full border border-gray-200 shadow-lg">
                  {channelUrls.map((item, idx) => (
                    <SelectItem
                      key={idx}
                      value={item.url}
                      className="text-sm hover:bg-red-100 cursor-pointer"
                    >
                      {item.url} - ({item.channelserver_name})
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="flex justify-end gap-4">
              <Button
                variant="outline"
                className="w-24  mt-0 hover:bg-red-500 hover:text-white border-red-500 text-red-500"
                onClick={() => setIsConnectDialogOpen(false)}
              >
                Cancel
              </Button>
              <Button
                //disabled={isUpdating || !selectedUrl}
                className="w-24 m-0"
                onClick={async () => {
                  setIsUpdating(true);
                  handleUpdateChannelServerUrl();
                  setIsConnectDialogOpen(false);
                  fetchChannelConfigs(partnerId);
                }}
              >
                {isUpdating ? "Saving..." : "Save"}
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          open={isDeliveryWindowDialogOpen}
          onOpenChange={setIsDeliveryWindowDialogOpen}
        >
          <DialogContent className="w-full max-w-md">
            <DialogHeader>
              <DialogTitle className="text-lg font-semibold text-[#09090B]">
                Message Validity Period
              </DialogTitle>
              <DialogDescription className="text-sm text-muted-foreground">
                Set the campaign expiry time below.
              </DialogDescription>
            </DialogHeader>

            <div className=" space-y-6">
              {/* Input + Select Row */}
              <div className="flex items-center gap-4">
                <Input
                  type="number"
                  value={ttlValue}
                  placeholder={unit === "hours" ? "Min 12" : "Max 72"}
                  className="w-36 h-10"
                  onChange={(e) => handleTTLChange(e.target.value)}
                  onBlur={handleTTLBlur} // 👈 add this
                />

                <div className="w-[130px] h-10 flex items-center px-3 border rounded-md bg-muted text-sm text-muted-foreground">
                  Hours
                </div>
              </div>

              {/* Hint Text */}
              <p className="text-xs text-muted-foreground">
                {unit === "hours" && (
                  <>
                    Minimum <b>2 hours</b> · Maximum <b>72 hours</b>
                  </>
                )}

                {/* {unit === "days" && (
  <>
    Minimum <b>0.08 days</b> · Maximum <b>3 days</b>
  </>
)} */}
              </p>
            </div>

            <DialogFooter className="flex justify-end gap-3 pt-2 ">
              <Button
                variant="outline"
                className="w-24 hover:bg-red-500 hover:text-white border-red-500 text-red-500 mt-4"
                onClick={() => {
                  setIsDeliveryWindowDialogOpen(false);
                  setTtlValue("");
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={
                  isUpdating ||
                  !ttlValue ||
                  Number(ttlValue) < 2 ||
                  Number(ttlValue) > 72
                }
                className="w-24 mt-4"
                onClick={() => {
                  updateDeliveryWindow(
                    Number(ttlValue),
                    unit,
                    selectedChannelConfigId,
                  );
                  setIsDeliveryWindowDialogOpen(false);
                }}
              >
                {isUpdating ? "Updating..." : "Update"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <Dialog
          open={isWelcomeTemplateDialogOpen}
          onOpenChange={setIsWelcomeTemplateDialogOpen}
        >
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Link Welcome Template</DialogTitle>
            </DialogHeader>
            <div>
              <Label>Select Template</Label>

              <Select
                value={selectedWelcomeTemplateId}
                onValueChange={setSelectedWelcomeTemplateId}
                onOpenChange={(open) => !open && setTemplateSearchQuery("")}
              >
                <SelectTrigger className="mt-2">
                  <SelectValue placeholder="Select a template" />
                </SelectTrigger>

                <SelectContent>
                  <div className="flex items-center px-3 pb-2 border-b">
                    <svg
                      className="w-4 h-4 text-gray-400 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                    <input
                      type="text"
                      placeholder="Search..."
                      value={templateSearchQuery}
                      onChange={(e) => setTemplateSearchQuery(e.target.value)}
                      className="flex-1 outline-none text-sm"
                      onClick={(e) => e.stopPropagation()}
                      onKeyDown={(e) => e.stopPropagation()}
                    />
                  </div>
                  <div className="max-h-[200px] overflow-y-auto">
                    {welcomeTemplateList.length > 0 ? (
                      welcomeTemplateList
                        .filter((template) =>
                          template.templateName
                            .toLowerCase()
                            .includes(templateSearchQuery.toLowerCase()),
                        )
                        .map((template: any) => (
                          <SelectItem
                            key={template.templateId}
                            value={template.templateId.toString()}
                          >
                            {template.templateName}
                          </SelectItem>
                        ))
                    ) : (
                      <div className="px-3 py-2 text-sm text-gray-500">
                        No templates available
                      </div>
                    )}
                  </div>
                </SelectContent>
              </Select>
            </div>

            <DialogFooter className="mt-6">
              <Button
                variant="outline"
                className="w-24"
                onClick={() => setIsWelcomeTemplateDialogOpen(false)}
              >
                Cancel
              </Button>
              <Button
                className="w-24"
                onClick={() => {
                  updateTemplateMapping(
                    selectedChannelConfigId,
                    Number(selectedWelcomeTemplateId),
                  );
                }}
              >
                Save
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        <Toaster />
        <div className="fixed flex justify-end gap-4 mr-[26px] items-end right-[0px] top-[-12px] z-20 ">
          <Button
            className="w-auto"
            onClick={() => {
              // launchWhatsAppSignup("addPhoneNumber");
              // checkTokenValidity();
              setIsConnectOpen(true);
            }}
          >
            Add Connection
          </Button>
          <Button
            variant="default"
            className="w-auto bg-[#479E98]"
            onClick={() => fetchChannelConfigs(partnerId)}
            disabled={isRefreshing}
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            {isRefreshing ? "Refreshing..." : "Refresh"}
          </Button>
        </div>

        <div className="rounded-md border mt-2">
          <div className="max-h-[60vh] overflow-y-auto">
            {/* First Table - Available Short Codes */}
            <Table
              className="rounded-xl whitespace-nowrap border-gray-200  "
              style={{ color: "#020202", fontSize: "15px" }}
            >
              <TableHeader className="text-center text-[14px] font-medium">
                <TableRow>
                  <TableHead className="">
                    <div className="flex items-center gap-6 justify-start cursor-pointer">
                      <input
                        type="checkbox"
                        // className={`text-muted-foreground ${
                        //   isAllSelected ? "accent-gray-700 bg-grey-700 text-red-500" : ""
                        // }`}
                        // checked={isAllSelected}
                        // onChange={handleSelectAll}
                      />
                    </div>
                  </TableHead>

                  <TableHead className="text-left">
                    <div className="flex items-center gap-2 justify-start">
                      Channel Name{" "}
                      <CaretSortIcon
                      // onClick={() => sortCampaignList("ByCampaignChannel")}
                      // className="cursor-pointer"
                      />
                    </div>
                  </TableHead>
                  <TableHead className="text-left">
                    <div className="flex items-center gap-2 justify-start">
                      Type{" "}
                      <CaretSortIcon
                      // onClick={() => sortCampaignList("ByCampaignStatus")}
                      // className="cursor-pointer"
                      />
                    </div>
                  </TableHead>
                  <TableHead className="text-left">
                    <div className="flex items-center gap-2 justify-start">
                      Config Status{" "}
                      <CaretSortIcon
                      // onClick={() => sortCampaignList("ByCampaignDate")}
                      // className="cursor-pointer"
                      />
                    </div>
                  </TableHead>
                  <TableHead className="text-left">
                    <div className="flex items-center gap-2 justify-start">
                      Channel Server Url{" "}
                      <CaretSortIcon
                      // onClick={() => sortCampaignList("ByCampaignStatus")}
                      // className="cursor-pointer"
                      />
                    </div>
                  </TableHead>
                  <TableHead className="text-left">
                    <div className="flex items-center gap-2 justify-start">
                      Channel App Status{" "}
                      <CaretSortIcon
                      // onClick={() => sortCampaignList("ByCampaignDate")}
                      // className="cursor-pointer"
                      />
                    </div>
                  </TableHead>
                  {/* <TableHead className="text-left">
                    <div className="flex items-center gap-2 justify-start">
                      Welcome Template{" "}
                      <CaretSortIcon
                      // onClick={() => sortCampaignList("ByCampaignDate")}
                      // className="cursor-pointer"
                      />
                    </div>
                  </TableHead> */}
                  <TableHead className="text-left"></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody className="text-left text-[14px] font-normal text-[#020617]">
                {tableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} className="text-center py-4">
                      No channel configurations found.
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((data: any, index) => (
                    <>
                      <TableRow key={data.channel_config_id}>
                        <TableCell className="py-4 text-left">
                          <input
                            type="checkbox"
                            className="accent-gray-700 bg-grey-700"
                            // Add a state and handler if you want to manage checkbox selection
                          />
                        </TableCell>
                        <TableCell className="py-4 text-left">
                          {data.channel_config_name}
                        </TableCell>
                        <TableCell className="py-4 text-left">
                          {data.api_type}
                        </TableCell>
                        <TableCell className="py-4 text-left">
                          <Badge
                            className={`w-fit inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium
      ${
        data.channel_status?.toLowerCase() === "active"
          ? "bg-green-100 text-green-700 border border-green-300 hover:bg-green-100"
          : "bg-red-100 text-red-700 border border-red-300 hover:bg-red-100"
      }`}
                          >
                            <span className="flex items-center gap-1">
                              <span
                                className={`w-2 h-2 rounded-full ${
                                  data.channel_status?.toLowerCase() ===
                                  "active"
                                    ? "bg-green-500"
                                    : "bg-red-500"
                                }`}
                              />
                              {data.channel_status}
                            </span>
                          </Badge>
                        </TableCell>
                        <TableCell className="py-4 text-left">
                          {data.channelserver_url}
                        </TableCell>
                        <TableCell className="py-4 text-left">
                          {["active", "inactive"].includes(
                            data.channelserver_app_status?.toLowerCase(),
                          ) ? (
                            <Badge
                              onClick={() =>
                                setOpenRow(openRow === index ? null : index)
                              }
                              className={`cursor-pointer w-fit inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium
        ${
          data.channelserver_app_status?.toLowerCase() === "active"
            ? "bg-green-100 text-green-700 border border-green-300 hover:bg-green-100"
            : "bg-red-100 text-red-700 border border-red-300 hover:bg-red-100"
        }`}
                            >
                              {data.channelserver_app_status?.toLowerCase() ===
                              "active" ? (
                                <span className="w-2 h-2 rounded-full bg-green-500" />
                              ) : (
                                <Info className="w-3 h-3 text-red-500" />
                              )}

                              {data.channelserver_app_status}
                            </Badge>
                          ) : (
                            <span className="text-sm ml-2 text-gray-700 capitalize">
                              {data.channelserver_app_status || "-"}
                            </span>
                          )}
                        </TableCell>

                        <TableCell></TableCell>
                        <TableCell>
                          <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                              <DotsHorizontalIcon className="cursor-pointer w-6 h-6" />
                            </DropdownMenuTrigger>
                            <DropdownMenuContent
                              className="w-52 translate-x-4 rounded-lg shadow-md border border-gray-200 cursor-pointer"
                              align="end"
                            >
                              <DropdownMenuItem
                                className="cursor-pointer"
                                onClick={() =>
                                  handleStatusToggle(
                                    data.channel_config_id,
                                    data.channel_status,
                                  )
                                }
                              >
                                {data.channel_status === "active"
                                  ? "Set as Inactive"
                                  : "Set as Active"}
                              </DropdownMenuItem>
                              <DropdownMenuItem
                                className="cursor-pointer"
                                onClick={() => {
                                  fetchChannelServerUrls();
                                  setCurrentChannelId(data.channel_config_id);
                                  setIsConnectDialogOpen(true);
                                }}
                              >
                                Connect to channel server
                              </DropdownMenuItem>

                              <DropdownMenuItem
                                className="cursor-pointer"
                                onClick={() =>
                                  getChannelConfigById(data.channel_config_id)
                                }
                              >
                                Edit
                              </DropdownMenuItem>

                              <DropdownMenuItem
                                className="cursor-pointer"
                                onClick={() =>
                                  openDeleteDialog(
                                    data.channel_config_id,
                                    data.channel_config_name,
                                  )
                                }
                              >
                                Delete
                              </DropdownMenuItem>
                              <DropdownMenuItem
                                className="cursor-pointer"
                                onClick={async () => {
                                  setSelectedChannelConfigId(
                                    data.channel_config_id,
                                  );

                                  await getTTLHours(data.channel_config_id);

                                  setIsDeliveryWindowDialogOpen(true);
                                }}
                              >
                                {data.wm_template_id
                                  ? "Edit Message Validity Period"
                                  : "Message Validity Period "}
                              </DropdownMenuItem>

                              {/* <DropdownMenuItem
                              className="cursor-pointer"
                              onClick={() => {
                                fetchWelcomeTemplates(
                                  data.channel_config_id,
                                  channelId,
                                );
                                setIsWelcomeTemplateDialogOpen(true);
                              }}
                            >
                              {data.wm_template_id
                                ? "Edit Welcome Template"
                                : "Link Welcome Template"}
                            </DropdownMenuItem> */}
                            </DropdownMenuContent>
                          </DropdownMenu>
                        </TableCell>
                      </TableRow>
                      {/* ✅ Expand Row */}
                      {openRow === index &&
                        data.channelserver_app_status?.toLowerCase() ===
                          "inactive" && (
                          <TableRow>
                            <TableCell colSpan={8} className="p-0">
                              <div className="flex items-start gap-3 bg-red-50 border-t border-red-200 px-4 py-3">
                                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-red-100 text-red-600">
                                  !
                                </div>

                                <div className="text-sm">
                                  <div className="font-medium mt-1 text-red-700">
                                    {data.channelserver_app_remarks ||
                                      "Error occurred"}
                                  </div>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                    </>
                  ))
                )}{" "}
              </TableBody>
            </Table>
          </div>
        </div>
        {/* Pagination Section */}
            <div className="flex justify-between items-center mt-4 px-4 pb-4">
              <div className="flex items-center space-x-2 text-gray-500 text-sm">
                <span>
                  {totalCount === 0
                    ? "0 of 0 row(s) selected"
                    : `${(currentPage - 1) * rowsPerPage + 1}-${Math.min(
                        currentPage * rowsPerPage,
                        totalCount,
                      )} of ${totalCount} row(s) selected`}
                </span>
              </div>
              <div className="flex items-center space-x-4 font-medium text-sm">
                <span className="text-[#020617] font-medium text-[14px]">
                  Rows per page
                </span>
                <div className="relative inline-block ml-2">
                  <select
                    disabled={totalCount === 0}
                    className={`cursor-pointer border border-gray-300 rounded-md px-2 py-1 appearance-none focus:outline-none focus:ring-1 focus:ring-blue-500 ${
                      totalCount === 0 ? "cursor-not-allowed bg-gray-100" : ""
                    }`}
                    style={{
                      width: "60px",
                      height: "30px",
                      textAlign: "left",
                      fontSize: "12px",
                      fontWeight: "400",
                      borderColor: "#E5E7EB",
                      boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
                    }}
                    value={rowsPerPage}
                    onChange={(e) => {
                      setRowsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    {[5, 10, 20].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                  <CaretSortIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500 w-4 h-4" />
                </div>
                <div className="ml-4 mr-4">
                  <span className="text-[#020617] text-[14px] font-medium">{`Page ${currentPage} of ${totalPages || 1}`}</span>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    disabled={currentPage === 1 || totalCount === 0}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === 1 || totalCount === 0
                        ? "cursor-not-allowed bg-gray-100"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => setCurrentPage(1)}
                  >
                    «
                  </button>
                  <button
                    disabled={currentPage === 1 || totalCount === 0}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === 1 || totalCount === 0
                        ? "cursor-not-allowed bg-gray-100"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    ‹
                  </button>
                  <button
                    disabled={currentPage === totalPages || totalCount === 0}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === totalPages || totalCount === 0
                        ? "cursor-not-allowed bg-gray-100"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    ›
                  </button>
                  <button
                    disabled={currentPage === totalPages || totalCount === 0}
                    className={`border p-1 pr-2 pl-2 rounded text-gray-500 ${
                      currentPage === totalPages || totalCount === 0
                        ? "cursor-not-allowed bg-gray-100"
                        : "hover:bg-gray-200"
                    }`}
                    onClick={() => setCurrentPage(totalPages)}
                  >
                    »
                  </button>
                </div>
              </div>
            </div>

        {isLoading && (
          <div className="flex flex-col items-center justify-center h-[500px]">
            <CircularProgress color="primary" />
          </div>
        )}
        {/* <AddPhone
        open={open}
        handleClose={handleClose}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        phone_Id={isEdit ? editPhoneId : 0}
        phone_Name={isEdit ? editPhoneName : ""}
        phone_Number={isEdit ? editPhoneNumber : ""}
        countryList={countryList}
        numberList={numberList}
      /> */}
      </>
    </>
  );
};

export default SMS;
